export default "__VITE_ASSET__DAeulGIJ__"